import type { Middleware } from 'redux';

import { call } from '@swf/core/api/embedded';

import type { RootState } from '../types';

const authLoginMiddleware: Middleware<object, RootState> = (storeApi) => (next) => (action) => {
  const rootState = storeApi.getState();
  const isEmbedded = rootState.device.embedded;
  const isOpeningLoginModal =
    ['modal/enqueue', 'modal/replace', 'modal/unshift'].includes(action.type) &&
    action.payload.path === '/auth/login';

  if (isOpeningLoginModal && isEmbedded) {
    call(['auth', 'login']);
    return;
  }

  return next(action);
};

export default authLoginMiddleware;
